// Get environment from URL in address bar.
import { Logger, LOG_DEBUG } from './logging';

export const getEnvironment = () => {
    if ( /localhost/.test( window.location.hostname ) ) {
        return 'qa';
    }

    return window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
        return [ 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
};

const env = getEnvironment();

/* eslint-disable */
// function getURL(url) {
//     const env = getEnvironment();
//     const resolvedURL = url.replaceAll('(account.)', env ? '-np' : '');
//     resolvedURL.replace('(env.)', env ? env + '.' : '');
//     return resolvedURL
// }

/**
 * getGantryUrl will fetch appropriate URL for the environment to connect to gantry data catalog
 *
 * @returns {string}
 */
const getGantryUrl = () => {
    Logger( LOG_DEBUG, `Inside getGantryUrl in this env ${ env }` );

    if ( env === 'qa' || env === 'pprd' ) {
        Logger( LOG_DEBUG, `getGantryUrl fetching non-prod endpoint` );
        return `https://${ env }.${ env }-superior-eu.dlake-np.api.biw.cloud/v1/gantry-data-catalog`;
    }

    Logger( LOG_DEBUG, `getGantryUrl fetching PROD endpoint` );
    return 'https://prod.superior-eu-prod.data-lake.api.biw.cloud/v1/gantry-data-catalog';
};

export const idURL = `https://${ env ? env+'.' : ''}api.biw.cloud/v1/id`;
export const gantryURL = getGantryUrl();
// Jason Local environment
// export const gantryURL = 'http://192.168.4.156:3838/api/v1';
